import { Injectable } from '@angular/core';

/**
 * Resolve `targetId` -> elemento real, apenas por atributo `data-tour`.
 * Considera "disponível" só o elemento realmente visível (desktop e mobile
 * podem ter o mesmo ID em hosts distintos; o oculto por breakpoint é ignorado).
 */
@Injectable({ providedIn: 'root' })
export class GuidedTourTargetResolverService {
  resolve(targetId: string): HTMLElement | null {
    const candidates = document.querySelectorAll<HTMLElement>(
      `[data-tour="${CSS.escape(targetId)}"]`
    );
    for (const element of Array.from(candidates)) {
      if (this.isUsable(element)) return element;
    }
    return null;
  }

  async waitFor(targetId: string, timeoutMs = 1500, intervalMs = 100): Promise<HTMLElement | null> {
    const deadline = Date.now() + timeoutMs;
    let element = this.resolve(targetId);
    while (!element && Date.now() < deadline) {
      await new Promise<void>((resolve) => setTimeout(resolve, intervalMs));
      element = this.resolve(targetId);
    }
    return element;
  }

  private isUsable(element: HTMLElement): boolean {
    if (!element.isConnected) return false;
    const rect = element.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0) return false;
    const style = getComputedStyle(element);
    return style.visibility !== 'hidden' && style.display !== 'none';
  }
}
